module.exports = __webpack_public_path__ + "img/28.26ce33f5.svg";